<template>
  <button
    @click="$emit('submit-click')"
    class="submit-cta"
  >
    <span>{{ label }}</span>
      <svg id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
        <path id="Unione_1" data-name="Unione 1" d="M10.793,22.708a1,1,0,0,1,0-1.415L19.585,12.5H1a1,1,0,0,1,0-2H19.585L10.793,1.706A1,1,0,0,1,12.206.293l10.5,10.5a1,1,0,0,1,.184.252h0l.01.02v0l.009.018,0,0,.008.017,0,.006.006.015,0,.009,0,.013,0,.011,0,.011,0,.013,0,.009,0,.014,0,.009,0,.016,0,.007,0,.017,0,.007,0,.017,0,.007,0,.016v.008l0,.016v.008l0,.015v.01l0,.014s0,.008,0,.013,0,.007,0,.011v.024c0,.006,0,.012,0,.018s0,0,0,.006,0,.015,0,.022v0c0,.008,0,.017,0,.025h0s0,.009,0,.014,0,.006,0,.01a1,1,0,0,1-.314.7l-10.48,10.48a1,1,0,0,1-1.413,0Z" fill="#fff"/>
      </svg>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

  .submit-cta::-moz-focus-inner, .submit-cta:focus {
    border: none;
    outline: none;
  }

  .submit-cta{

    svg{
      width: 23px;
      height: 23px;
      transform: translate3d(0, 0, 0);
      transition: transform .8s cubic-bezier(.23,1,.32,1);
      position: absolute;
      top: calc(50% - 12px);
      right: 20px;
    }
    &:hover svg{
      transform: translate3d(50px, 0, 0);
      transition-delay: .2s;
    }

    &{
      position: relative;
      display: inline-block;
      padding: 20px 120px 20px 25px;
      font-size: .9rem;
      background-color: #30AE8D;
      border: 1px solid #30AE8D;
      color: #FFF;
      cursor: pointer;
      outline: 0;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      transition: all 0.3s;
      text-align: left;

      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 700;
      text-transform: uppercase;
      text-decoration: none;
      overflow: hidden;
      letter-spacing: 2px;

      @media #{$large_mq} {
        font-size: 1rem;
        padding: 25px 150px 25px 28px;
      }
      @media #{$xlarge_mq} {
        font-size: 1.25rem;
        padding: 29px 172px 29px 32px;
      }
    }

  }
</style>
